/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Grid, Card, Image, Icon, Popup } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import CredibilityIcon from 'assets/images/credibility.svg';
import currencyFormat from 'utils/currencyFormat';
import { capitalizeEachWords } from 'utils/capitalize';
import SaveScoreBandPopup from 'containers/Organizations/SingleOrganization/Profiles/SingleProfile/Requests/SingleRequest/SaveScoreBandPopup';

const hrStyle = {
  width: '100%',
  height: '1px',
  marginTop: '5px',
  marginBottom: '5px',
  backgroundColor: '#EBEBEB',
  border: 'none',
  color: '#EBEBEB',
};

const getCreditScoreColor = creditScore => {
  if (creditScore >= 300 && creditScore <= 559) {
    return '#DB2829';
  }
  if (creditScore >= 560 && creditScore <= 649) {
    return '#FF5630';
  }
  if (creditScore >= 650 && creditScore <= 699) {
    return '#D77501';
  }
  if (creditScore >= 700 && creditScore <= 749) {
    return '#00E485';
  }
  if (creditScore >= 750 && creditScore <= 850) {
    return '#029357';
  }
  return 'grey';
};

const MemberSaveScoreInfo = ({ data }) => {
  return (
    <Card className="member-save-score-info">
      <Card.Content>
        <Grid className="">
          <Grid.Column width="16">
            <Grid.Row
              columns="1"
              className="member-save-score-info__row"
            >
              <Grid>
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    fontWeight: 'bolder',
                    textAlign: 'center',
                    marginBottom: '10px',
                  }}
                >
                  <span>
                    SAVE Score{' '}
                    <Popup
                      trigger={
                        <Icon name="info circle" color="blue" />
                      }
                      content={<SaveScoreBandPopup />}
                      on="click"
                      hoverable
                      position="left center"
                    />
                  </span>
                </div>
              </Grid>
            </Grid.Row>
            <Grid.Row
              columns="1"
              className="member-save-score-info__row"
            >
              <Grid>
                {/* <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    Member Save Score
                  </div>
                </Grid.Column> */}
                <Grid.Column
                  columns="8"
                  className=""
                  style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <div className="flex flex-center-vertical">
                    <Image
                      src={CredibilityIcon}
                      style={{
                        margin: 0,
                        width: '50px',
                      }}
                    />
                    <span
                      style={{
                        color: getCreditScoreColor(
                          data?.member_info?.loan_score ||
                            data?.member_info?.loan_score_metadata
                              ?.loan_score,
                        ),
                        fontWeight: 'bolder',
                        fontSize: '40px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {data?.member_info?.loan_score ||
                        data?.member_info?.loan_score_metadata
                          ?.loan_score}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
            <Grid.Row
              columns="1"
              className="member-save-score-info__row"
            >
              <Grid>
                <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    Risk Rating
                  </div>
                </Grid.Column>
                <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div className="flex flex-center-vertical member-save-score-info__value">
                    {/* <Image
                      src={RatingIcon}
                      style={{
                        margin: 0,
                      }}
                    /> */}
                    <span
                      style={{
                        fontWeight: 'bolder',
                        fontSize: '16px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {capitalizeEachWords(
                        data?.member_info?.loan_risk_level ||
                          data?.member_info?.loan_score_metadata
                            ?.loan_risk_level,
                      )}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
            <hr className="" style={hrStyle} />
            <Grid.Row
              columns="1"
              className="member-save-score-info__row"
            >
              <Grid>
                <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    Loan Limit (Rwf)
                  </div>
                </Grid.Column>
                <Grid.Column
                  columns="8"
                  className="member-save-score-info__50_percent"
                  style={{ width: '50%' }}
                >
                  <div className="flex flex-center-vertical member-save-score-info__value">
                    <span
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'right',
                        fontSize: '18px',
                        letterSpacing: '0.75px',
                        marginLeft: '5px',
                      }}
                    >
                      {currencyFormat(
                        data?.member_info?.loan_limit ||
                          data?.member_info?.loan_score_metadata
                            ?.loan_limit,
                        '',
                      )}
                    </span>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Row>
          </Grid.Column>
        </Grid>
      </Card.Content>
    </Card>
  );
};

MemberSaveScoreInfo.propTypes = {
  data: PropTypes.objectOf(Object).isRequired,
};

export default MemberSaveScoreInfo;
